import Select from 'src/components/primitives/Select/Select';
import Input from 'src/components/primitives/Input/Input';
import {
	AlertFrequency,
	AlertType,
	ALERT_FREQUENCY_LABELS,
	ALERT_TYPE_LABELS,
} from './types';
import { usePerpMarkets } from 'src/hooks/perpMarkets/usePerpMarkets';
import { useCreateAlertForm } from './hooks/useCreateAlertForm';

interface CreateAlertFormProps {
	form: ReturnType<typeof useCreateAlertForm>;
}

export default function CreateAlertForm({ form }: CreateAlertFormProps) {
	const perpMarkets = usePerpMarkets();

	const handleMarketChange = (v: string) => {
		const idx = Number(v);
		form.setMarketIndex(idx);
		const market = perpMarkets.find(
			(m: { marketIndex: number }) => m.marketIndex === idx
		);
		if (market) {
			form.setMarketSymbol(market.symbol);
		}
	};

	return (
		<div className="flex flex-1 flex-col gap-lg overflow-y-auto">
			<Select.Root
				value={form.marketIndex?.toString() ?? ''}
				onValueChange={handleMarketChange}
			>
				<Select.Trigger size="md" label="Market">
					{form.marketSymbol || 'Select Market'}
				</Select.Trigger>
				<Select.Options>
					{perpMarkets.map(
						(market: { marketIndex: number; symbol: string }) => (
							<Select.Option
								key={market.marketIndex}
								value={market.marketIndex.toString()}
							>
								{market.symbol}
							</Select.Option>
						)
					)}
				</Select.Options>
			</Select.Root>

			<Select.Root
				value={form.alertType ?? ''}
				onValueChange={(v) => form.setAlertType(v as AlertType)}
			>
				<Select.Trigger size="md" label="Alert Type">
					{form.alertType ? ALERT_TYPE_LABELS[form.alertType] : 'Select Type'}
				</Select.Trigger>
				<Select.Options>
					{(Object.entries(ALERT_TYPE_LABELS) as [AlertType, string][]).map(
						([key, label]) => (
							<Select.Option key={key} value={key}>
								{label}
							</Select.Option>
						)
					)}
				</Select.Options>
			</Select.Root>

			<Input
				id="alert-value"
				labelVariant="standard"
				label="Value"
				type="number"
				value={form.value}
				onChange={form.setValue}
				placeholder="0"
				suffix="%"
			/>

			<Select.Root
				value={form.frequency ?? ''}
				onValueChange={(v) => form.setFrequency(v as AlertFrequency)}
			>
				<Select.Trigger size="md" label="Frequency">
					{form.frequency
						? ALERT_FREQUENCY_LABELS[form.frequency]
						: 'Select Frequency'}
				</Select.Trigger>
				<Select.Options>
					{(
						Object.entries(ALERT_FREQUENCY_LABELS) as [AlertFrequency, string][]
					).map(([key, label]) => (
						<Select.Option key={key} value={key}>
							{label}
						</Select.Option>
					))}
				</Select.Options>
			</Select.Root>
		</div>
	);
}
